import React, { useRef } from "react";
import { Form, Formik, FormikProps } from "formik";
import Grid from "@material-ui/core/Grid/Grid";
import * as Yup from "yup";
import { useHistory, useParams } from "react-router-dom";
import CustomButton from "../../../../../components/Button/CustomButton";
import ProductApi from "../../../../../api/services/ProductApi";
import useEnv from "../../../../../hooks/env";
import CompetitorProduct from "../../../../../api/models/product/CompetitorProduct";
import { ProductReferenceResponseWithType } from "../../../../../api/models/ProductReferenceResponse";
import {
  CompetitorProductAutocomplete,
  CompetitorSampleAddFormProps,
  CompetitorSampleAddFormType,
} from "./CompetitorSuggestionForm";
import useStyles from "./CompetitorSuggestionFromStyle";
import CustomTextField from "../../../../../components/Input/CustomTextField";
import { getCompetitorProductFullName } from "../../forms/productReferenceHelper";
import RequestsPagePathParams from "../../../../../api/models/test-request/RequestsPagePathParams";

const createInitialValues = (preset: ProductReferenceResponseWithType | null | undefined) => {
  if (preset) {
    return {
      id: preset?.competitorProductId,
      name: preset?.competitorProductName || "",
      company: {
        id: preset?.competitorCompanyId,
        name: preset?.competitorCompanyName || "",
        contact: null,
      },
      color: null,
      adhesive: null,
      backing: null,
      thickness: null,
      tesaCoverName: null,
      attachments: [],
      creationDate: null,
    } as unknown as CompetitorProduct;
  }
  return null;
};

const CompetitorSampleAddFormEmployee = (props: CompetitorSampleAddFormProps) => {
  const { api } = useEnv();
  const competitorSearch = useRef<{ reset: () => void }>(null);

  const productApi = new ProductApi(api);
  const classes = useStyles(props);
  const history = useHistory();
  const { hideSubmit, handleSubmit, preset, disabled, suggestion, notFoundLink } = props;
  const { testRequestId, tabName } = useParams<RequestsPagePathParams>();

  const yupValidationSchema = Yup.object().shape({
    product: Yup.mixed().required("Please select"),
  });

  const handleNavigation = () => {
    localStorage.setItem("recentReqId", testRequestId);
    localStorage.setItem("recentTab", tabName);
    localStorage.setItem("recentDialog", "");
    history.push("/products/competitor/createProduct");
  };

  return (
    <Formik<CompetitorSampleAddFormType>
      initialValues={{
        product: createInitialValues(preset),
      }}
      onSubmit={(values) => {
        if (handleSubmit) {
          handleSubmit(values);
        }
      }}
      validationSchema={yupValidationSchema}
    >
      {(formikProps: FormikProps<CompetitorSampleAddFormType>): JSX.Element => {
        const { isSubmitting, setFieldValue, values, errors, touched } = formikProps;

        return (
          <Form>
            <Grid container justify="flex-start" direction="row" spacing={4}>
              {suggestion && (
                <Grid item xs={12}>
                  <CustomTextField
                    fullWidth
                    disabled
                    id="competitorProductSuggestion"
                    label="Product suggested by the requestor"
                    value={suggestion}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <CompetitorProductAutocomplete
                  ref={competitorSearch}
                  disabled={disabled}
                  inputLabel="Product"
                  map={(value): { key: string; label: string } => {
                    return {
                      key: `${value.id}`,
                      label: getCompetitorProductFullName(value?.name, value?.company?.name),
                    };
                  }}
                  optionFetch={(term: string) => {
                    return productApi.getCompetitorProduct(term, "").then((res) => res?.data);
                  }}
                  onChange={(e, val) => {
                    setFieldValue("product", val);
                  }}
                  value={values.product}
                  error={!!(errors.product && touched.product)}
                />
              </Grid>
            </Grid>
            {notFoundLink && (
              <Grid container item direction="row" justify="flex-start">
                <span onClick={handleNavigation} className="helperTextLink" role="link" tabIndex={0}>
                  Not found? Create new Competitor Product
                </span>
              </Grid>
            )}
            {!hideSubmit && (
              <Grid container item direction="row" justify="flex-end">
                <CustomButton
                  className={classes.marginTop}
                  disabled={isSubmitting}
                  primary
                  text="Use Competitor Product"
                  type="submit"
                />
              </Grid>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default CompetitorSampleAddFormEmployee;
